<template>
    <div>
        <div class="color-size-main-wrapper">
            <div class="img-preview-section">
                <div class="img-preview-background-wrapper" :style="'background-color:' + store.colorSizeLines[store.imprintKey][lineIndex].slectedColor.title.toLowerCase()">
                    <img
                        class="img-preview-section__img"
                        :src="store.colorSizeLines[store.imprintKey][lineIndex].slectedColor.img_src"
                        :alt="store.colorSizeLines[store.imprintKey][lineIndex].slectedColor.alt"
                    >
                </div>
                <div v-if="store.colorSizeLines[store.imprintKey].length > 1" class="remove-color-line-wrapp">
                    <span :class="['remove-color-line__btn', customColor]" @click="deleteLineSelectedColorSize(lineIndex)">Remove</span>
                </div>
            </div>
            <div class="color-size-section">
                <label for="color-row" class="color-row-label">
                     Product {{getColorText()}}: <span class="color-row-label--sub">{{ store.colorSizeLines[this.store.imprintKey][lineIndex].slectedColor.title.replace(' with ',' ').split(' ').join('-').toUpperCase() }}</span>
                </label>
                <div id="color-row" class="color-row">
                    <template v-for="color in colorVariants" :key="color.id">
                        <button
                            v-if="!isColorHidden(color)"
                            class="color-picker-btn"
                            style=""
                            :title="color.title.replace('-', ' ').toUpperCase()"
                            :style="color.title ? 'background-image:url(' + colorCatalogBaseUrl + color.title.replace(' with ',' ').split(' ').join('-').toLowerCase() + '.png)': ''"
                            @click="setSelectedColor(color)"
                            :class="store.colorSizeLines[store.imprintKey][lineIndex].slectedColor.id == color.id ? 'color-picker-btn--selected' : ''"
                        >
                        </button>
                    </template>
                </div>

                <label for="size-row" class="size-row-label">
                    Quantity
                </label>
                <div id="size-row" class="size-row">
                    <template v-for="size in sizeVariants" :key="size.id">
                        <template v-if="hasColorSize(size.title)">
                            <CustomQty
                                :modelValue="store.colorSizeLines[store.imprintKey][lineIndex].selectedSizes[size.title] ? store.colorSizeLines[store.imprintKey][lineIndex].selectedSizes[size.title] : 0"
                                :sizeTitle="size.title"
                                :lineId="lineIndex"
                                @customQtyChange="updateStoreState"
                                @showQtyError="checkErrorQty"
                            >
                            </CustomQty>
                        </template>
                    </template>
                </div>
            </div>
        </div>
       <div class="error-qty" v-if="qtyError">{{qtyError}}</div>
    </div>
</template>

<script>
/* eslint-disable */
    import axios from 'axios';
    import { store } from './store'
    import CustomQty from './CustomQty.vue';
    import functions from "@/helpers/functions";

    export default {
        props: {
            lineIndex: Number,
            getColorText: Function
        },
        components: {
            CustomQty
        },
        data() {
            return {
                activeTab: 1,
                associated_aliases: { colors: '', sizes: '', product_type: '', main:'' },
                colorVariants: {},
                // TODO can be used data about variant only from store
                sizeVariants: [],
                colors: [],
                // TODO check if need sizes: []
                sizes: [],
                slectedColor: {
                    id: null,
                    title: ''
                },
                // TODO remove after testing
                sizesQty: {},
                store: store,
                responseProduct: {},
                associatedIds: {},
                s3BucketDomain: 'https://prod-imprint-uploads.s3.ca-central-1.amazonaws.com',
                colorCatalogBaseUrl: '/assets/images/imprint_app/colors/',
                oneSizeField: {
                    title: 'qty'
                },
                qtyError: null,
                defaultImage: null,
                functions: functions,
                enabledSizesForColor:{}
            }
        },
        methods: {
            init() {
                if(window.PXUTheme.theme_settings.s3_bucket_host) {
                    this.s3BucketDomain = window.PXUTheme.theme_settings.s3_bucket_host;
                    this.colorCatalogBaseUrl = this.s3BucketDomain + this.colorCatalogBaseUrl;
                }

                if(window.PXUTheme.theme_settings.color_img_placeholder) {
                  this.defaultImage= window.PXUTheme.theme_settings.color_img_placeholder;
                }
            },
            hasColorSize(sizeTitle) {
                // Для grouped_plain нічого не фільтруємо
                if (this.store.productType === 'grouped_plain') {
                    return true;
                }

                const imprintKey = this.store.imprintKey;

                const linesForImprint =
                    this.store.colorSizeLines && this.store.colorSizeLines[imprintKey];

                const line =
                    linesForImprint && linesForImprint[this.lineIndex];

                // Якщо ще немає вибраного кольору – показуємо всі розміри, але логимо
                if (!line || !line.slectedColor || !line.slectedColor.title) {
                    console.warn(
                        '[ColorSizePickerComponent] hasColorSize: немає поточного кольору для лінії',
                        {
                            imprintKey,
                            lineIndex: this.lineIndex,
                            line
                        }
                    );
                    return true;
                }

                const currentColor = line.slectedColor.title;

                const fullJson = this.store.inputProductData
                    ? this.store.inputProductData.fullJson
                    : null;

                const sku = this.store.selectedImprint
                    ? this.store.selectedImprint.sku
                    : null;

                const attrRel =
                    fullJson &&
                    fullJson.configurable_array &&
                    fullJson.configurable_array[sku] &&
                    fullJson.configurable_array[sku].attributes_relation_array;

                let sizesForCurrentColor =
                    attrRel && attrRel[currentColor];

                // якщо у вузлі є sku_color_code – зберігаємо його
                if (
                    sizesForCurrentColor &&
                    typeof sizesForCurrentColor === 'object' &&
                    !Array.isArray(sizesForCurrentColor) &&
                    sizesForCurrentColor.sku_color_code
                ) {
                    this.store.sku.color_code = sizesForCurrentColor.sku_color_code;
                }

                const enabledForColor =
                    this.enabledSizesForColor &&
                    this.enabledSizesForColor[currentColor];

                // якщо мапи enabledSizesForColor ще немає – не ховаємо розмір
                const conditionEnabledSimple = enabledForColor
                    ? Object.prototype.hasOwnProperty.call(enabledForColor, sizeTitle)
                    : true;

                // Головний момент:
                // якщо sizesForCurrentColor ще не масив – вважаємо, що розмір є (щоб не ховати поле)
                if (!Array.isArray(sizesForCurrentColor)) {
                    console.warn(
                        '[ColorSizePickerComponent] hasColorSize: sizesForCurrentColor не масив, показуємо розмір за замовчуванням',
                        {
                            currentColor,
                            sku,
                            sizesForCurrentColor
                        }
                    );
                    return conditionEnabledSimple;
                }

                const hasSize = sizesForCurrentColor.some(
                    (item) => item.size === sizeTitle
                );

                return hasSize && conditionEnabledSimple;
            },

            getEnabledColors(){
                let disabledColors = []

                for (var key in this.store.selectedImprint.data.simple_array) {
                    if(this.store.selectedImprint.data.simple_array[key].status == 'Disabled'){
                        disabledColors.push(this.store.selectedImprint.data.simple_array[key].sku);
                    }
                }

                let enabledColors = [];

                this.colorVariants.forEach(function (item) {
                    if (!disabledColors.includes(item.sku)) {
                        enabledColors.push(item);
                    }
                });

                return enabledColors;
            },
            getColorVariants(handle) {
                axios.get(window.Shopify.routes.root + 'products/' + handle + '.js')
                .then(response => {
                        this.colorVariants = response.data.variants.filter(item => !item.title.includes("_temp_"));
                        this.colorVariants = this.getEnabledColors();
                        this.store.inputProductData.colorVariants.data = this.colorVariants;

                        if(!this.store.availableColorsList.length) {
                            this.store.availableColorsList = this.colorVariants.map(function(item) {
                                return item.id;
                            });
                            this.$emit('colorLoaded', this.store.availableColorsList.length);
                        }

                        if(this.store.colorSizeLines[this.store.imprintKey][this.lineIndex].slectedColor.id === null) {
                            this.setSelectedColor(this.colorVariants[0]);
                        }
                        console.log('colors');
                        console.log(this.colorVariants);
                        console.error('>>>>>>>>>>>> Product by handle >>>>>>>>>>>');
                        console.log(response.data);
                        console.warn(this.store.inputProductData.colorVariants.data);
                    }
                );

            },
            getSizeVariants(handle) {
                axios.get(window.Shopify.routes.root + 'products/' + handle + '.js')
                .then(response => {
                        this.sizeVariants = response.data.variants;
                        this.store.inputProductData.sizeVariants.data = this.sizeVariants;

                        console.error("111111111111111 this.sizeVariants 111111111111111");
                        console.error(this.sizeVariants);

                        response.data.variants.filter(
                            item => {
                                if(item.title.length > 4) {
                                    this.store.hasFullSizeNames = true;
                                }
                                if(!item.sku.includes(item.title)) {
                                    this.store.hasFullSizeNames = true;
                                }
                                this.sizes.push(item.title);
                            }
                        );
                    }
                );
            },
            getMainVariant() {
                axios.get(window.Shopify.routes.root + 'products/' + this.associated_aliases.main + '.js')
                .then(response => {
                        this.store.mainVariantId = response.data.variants[0].id;
                    }
                );
            },
            getAliases() {
                let aliaces = JSON.parse(document.getElementById("associated_aliases").innerHTML);
                console.error(">>>> aliaces <<<<<");
                console.log(aliaces);
                this.associated_aliases = aliaces;
            },
            getAssociatedIds() {
                let associatedIds = JSON.parse(document.getElementById("associated_id").innerHTML);
                this.associatedIds = associatedIds;
                this.store.inputProductData.associatedIds = associatedIds;

                let productColor = this.store.inputProductData.associatedIds.simples.id_color;
                
                if(Array.isArray(productColor)) {
                    this.store.inputProductData.associatedIds.simples.id_color = productColor[productColor.length - 1];
                }
                console.warn("this.associatedIds");
                console.warn(this.associatedIds);
            },
            setSelectedColor(colorVariant) {
                console.log('Request selected color', colorVariant);

                if (!colorVariant) {
                    console.warn('[ColorSizePickerComponent] setSelectedColor: colorVariant is falsy');
                    return;
                }

                const imprintKey = this.store.imprintKey;

                // гарантуємо, що selectedColorsList існує
                if (!this.store.selectedColorsList) {
                    this.store.selectedColorsList = {};
                }

                // гарантуємо, що для поточного imprintKey є масив
                if (!Array.isArray(this.store.selectedColorsList[imprintKey])) {
                    this.store.selectedColorsList[imprintKey] = [];
                }

                const selectedColors = this.store.selectedColorsList[imprintKey];

                // додаємо id кольору, якщо його ще немає
                if (!selectedColors.includes(colorVariant.id)) {
                    selectedColors.push(colorVariant.id);
                }

                // оновлюємо поточну лінію colorSizeLines
                const linesForImprint = this.store.colorSizeLines && this.store.colorSizeLines[imprintKey];
                const line =
                    linesForImprint && linesForImprint[this.lineIndex];

                if (!line) {
                    console.warn(
                        '[ColorSizePickerComponent] setSelectedColor: line not found',
                        { imprintKey, lineIndex: this.lineIndex, linesForImprint }
                    );
                    return;
                }

                if (!line.slectedColor) {
                    line.slectedColor = {};
                }

                // мінімальний набір полів – підлаштуй під свою структуру
                line.slectedColor.id = colorVariant.id;
                line.slectedColor.title = colorVariant.title || colorVariant.label || line.slectedColor.title || null;
                line.slectedColor.hex =
                    colorVariant.hex ||
                    colorVariant.color_hex ||
                    line.slectedColor.hex ||
                    null;

                // якщо є розмір/додаткові поля – можна теж тут оновити

                console.log(
                    '[ColorSizePickerComponent] setSelectedColor: updated',
                    {
                        imprintKey,
                        lineIndex: this.lineIndex,
                        slectedColor: line.slectedColor,
                        selectedColorsList: this.store.selectedColorsList
                    }
                );
            },
            async getProductById(id, type) {
                let response = null;

                // Get handle or init if getted
                if(type === 'color' && this.store.inputProductData.colorVariants.handle === null) {
                    response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
                    this.responseProduct = response !== null ? response.data : null;
                    this.store.inputProductData.colorVariants.handle = this.responseProduct ? this.responseProduct.resources.results.products[0].handle : null;
                }

                if(type === 'size' && this.store.inputProductData.sizeVariants.handle === null) {
                    response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
                    this.responseProduct = response !== null ? response.data : null;
                    this.store.inputProductData.sizeVariants.handle = this.responseProduct ? this.responseProduct.resources.results.products[0].handle : null;
                }

                // Get Variants by handle or init if getted
                if(type == 'color') {
                    if(this.store.inputProductData.colorVariants.data === null) {
                        this.getColorVariants(this.responseProduct.resources.results.products[0].handle);

                    } else {
                        this.colorVariants = this.store.inputProductData.colorVariants.data;
                    }
                }
                if(type == 'size') {
                    if(this.store.inputProductData.sizeVariants.data === null) {
                        this.getSizeVariants(this.responseProduct.resources.results.products[0].handle);

                    } else {
                        this.sizeVariants = this.store.inputProductData.sizeVariants.data;
                    }
                }
            },
            deleteLineSelectedColorSize(index) {
                let colorID = null;
                let colorIndex = null;

                if(this.store.colorSizeLines[this.store.imprintKey][index] !== undefined) {
                    colorID = this.store.colorSizeLines[this.store.imprintKey][index].slectedColor.id;
                    colorIndex = this.store.selectedColorsList[this.store.imprintKey].indexOf(colorID);
                    this.store.selectedColorsList[this.store.imprintKey].splice(colorIndex,1);
                    this.store.colorSizeLines[this.store.imprintKey].splice(index,1);
                }

                console.log('result deleting');
                console.log(this.store.colorSizeLines);

                console.error(">>>> size Variants");
                console.log(this.sizeVariants);
                console.warn("this.store.colorSizeLines");
                console.warn(this.store.colorSizeLines);
                this.calculateTotal();
              //  this.$emit('lineRemoved', {value: index});
            },
            selectDefaultColorByLine() {
                const notSelectedColorVariant = this.getNotSelectedColor();

                // якщо ще немає доступних кольорів – тихо виходимо
                if (!Array.isArray(notSelectedColorVariant) || notSelectedColorVariant.length === 0) {
                    console.warn(
                            '[ColorSizePickerComponent] selectDefaultColorByLine: colorVariants.data ще не готові',
                            {
                                imprintKey: this.store.imprintKey,
                                lineIndex: this.lineIndex,
                                inputProductData: this.store.inputProductData,
                            }
                    );
                    return;
                }

                if (
                    this.store.colorSizeLines[this.store.imprintKey] &&
                    this.store.colorSizeLines[this.store.imprintKey][this.lineIndex] &&
                    this.store.colorSizeLines[this.store.imprintKey][this.lineIndex].slectedColor &&
                    this.store.colorSizeLines[this.store.imprintKey][this.lineIndex].slectedColor.id === null
                ) {
                    this.setSelectedColor(notSelectedColorVariant[0]);
                }

                console.error('addNewColorSizeLine');
                console.log(notSelectedColorVariant);
                console.log(this.store.selectedColorsList);
        },
        getNotSelectedColor() {
            const imprintKey = this.store.imprintKey;

            const selectedColors =
                (this.store.selectedColorsList && this.store.selectedColorsList[imprintKey]) || [];

            const colorData =
                this.store.inputProductData &&
                this.store.inputProductData.colorVariants &&
                this.store.inputProductData.colorVariants.data;

            // якщо даних про кольори ще немає – повертаємо порожній список
                if (!Array.isArray(colorData)) {
                console.warn(
                        '[ColorSizePickerComponent] getNotSelectedColor: colorVariants.data не масив',
                        this.store.inputProductData && this.store.inputProductData.colorVariants
                    );
                return [];
            }

            return colorData.filter((variant) => {
                return !selectedColors.includes(variant.id);
            });
        },
            isColorHidden(color) {
                let result = false;
                let currentLineIndex = this.lineIndex;

                if(color.title.includes("_temp_")) {
                    result = true;
                } else {
                    this.store.colorSizeLines[this.store.imprintKey].forEach(function(item, index) {
                        console.warn(currentLineIndex);
                        if(index !== currentLineIndex && item.slectedColor.id == color.id) {
                            result = true;
                        }
                    });
                }

                return result;
            },
            // Qty functions
            addOneQtyField() {
                this.sizeVariants.push(this.oneSizeField);
                this.store.inputProductData.sizeVariants.data = this.sizeVariants;
                console.error("???????????????addOneQtyField");
                console.log(this.store.colorSizeLines);
                let key = 1;

                if (this.store.isEnvelopProduct && store.prices.tier.length == 1) {
                    /*Calendar Envelop product contains only one price */
                    key = 0;
                }

                if(this.store.inputProductData.minOrderQty && !this.store.colorSizeLines[this.store.imprintKey][0].selectedSizes.qty) {
                 this.store.colorSizeLines[this.store.imprintKey][0].selectedSizes.qty = store.prices.tier[key].QtyMin ? store.prices.tier[key].QtyMin : 0;
                }
            },
            updateStoreState(value) {
                console.error("!!!!!!!!!!!!!!!!!!updateStoreState");
                console.log(value);

                if(value !== null){
                    this.store.colorSizeLines[this.store.imprintKey][value.lineIndex].selectedSizes[value.title] = parseInt(value.value, 10);
                }

                this.calculateTotal();
            },
            calculateTotal() {
                // TODO rename total to totalQty
                let total = 0;
                let qtyByLine = 0;
                let priceByQty = 0;
                let upchargePrice = 0;
                let colorUpcharge = 0;
                // TODO not used variable 28.08.2024
                let minOrderQty = store.inputProductData.minOrderQty;
                let hasSpecialPrice = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);

                console.warn("@@@@@@@@@ this.store.colorSizeLines @@@@@@@@@@@");
                console.log(this.store.colorSizeLines);

                this.store.colorSizeLines[this.store.imprintKey].forEach(
                    item => {
                        if(Object.values(item.selectedSizes).length){
                            qtyByLine = Object.values(item.selectedSizes).reduce((previous, current, index) => previous + current),0;
                            total += qtyByLine;
                        }
                    }
                );

                this.store.prices.tier.forEach(
                    item => {
                        if(item.QtyMin !== 'MSRP') {
                            if (total >= item.QtyMin) {
                                const b2bPrice = this.functions.getB2BPriceForTier(item, this.store.prices.b2bTier);
                                if (b2bPrice !== null) {
                                    priceByQty = b2bPrice;
                                } else {
                                    priceByQty = this.functions.isValidatedSpecialPrice(item) ? item['sale_price'] : item.price;
                                }
                            }
                        }
                    }
                );

              this.store.prices.priceByQty = priceByQty;
              this.store.prices.priceColorUpcharge = 0;
              this.store.upchargesLines[this.store.imprintKey] ={};
              this.store.upchargesLines[this.store.imprintKey].size ={};
              this.store.upchargesLines[this.store.imprintKey].color ={};
              this.store.colorSizeLines[this.store.imprintKey].forEach(
                    item => {
                        console.warn(item.selectedSizes);
                        for (const prop in item.selectedSizes) {
                        console.warn("prop");
                        console.warn(prop);
                            // TODO this.store.inputProductData.sizeUpcharge[prop] not work if prop == 'qty' check if condition wark if not set in upcharges
                            if(prop !=='qty' && this.store.inputProductData.sizeUpcharge[prop] !== undefined ) {
                                let priceByEl = (this.store.inputProductData.sizeUpcharge[prop] * item.selectedSizes[prop]);
                                upchargePrice += priceByEl;

                                if(item.selectedSizes[prop] > 0) {
                                    if(!this.store.upchargesLines[this.store.imprintKey].size.hasOwnProperty(prop)){
                                        this.store.upchargesLines[this.store.imprintKey].size[prop] = 0;
                                    }
                                    this.store.upchargesLines[this.store.imprintKey].size[prop] += priceByEl;
                                }
                            }
                            console.error(">>> " + prop + " >> " + item.selectedSizes[prop] + " >>>>>");

                            // TODO this.store.sizeUpcharge[prop] not work if prop == 'qty'
                            //console.error(this.store.sizeUpcharge[prop]);
                        }

                        let colorTitle = item.slectedColor.title;
                        // TODO this.store.inputProductData.sizeUpcharge[prop] not work if prop == 'qty' check if condition wark if not set in upcharges

                      if (typeof colorTitle === 'string') {
                        colorTitle = colorTitle.replace(' with ', ' ').split(' ').join('-');
                      }

                      if(this.store.inputProductData.colorUpcharge[colorTitle] !== undefined ) {
                            let priceByEl = 0;
                            if(Object.values(item.selectedSizes).length) {
                              qtyByLine = Object.values(item.selectedSizes).reduce((previous, current, index) => previous + current), 0;
                            }
                            if (this.store.inputProductData.colorUpcharge[colorTitle].price_type === "%") {
                              let priceUpcharge = priceByQty * (this.store.inputProductData.colorUpcharge[colorTitle].price / 100);
                              priceByEl = (priceUpcharge * qtyByLine);
                              if ((priceUpcharge + priceByQty).toFixed( 2) == priceByQty) {
                                priceByEl = 0;
                              }
                            } else {
                              priceByEl = (this.store.inputProductData.colorUpcharge[colorTitle].price * qtyByLine);
                            }

                            colorUpcharge += priceByEl;
                            console.log('color-upcharge!!!!' + colorTitle + "   " + priceByEl);
                            console.log(colorUpcharge);
                            if(priceByEl != 0) {
                              this.store.upchargesLines[this.store.imprintKey].color[colorTitle] = priceByEl;
                            }
                        }
                        console.error(">>> " + colorTitle + " >> " + this.store.inputProductData.colorUpcharge[colorTitle] + " >>>>>");
                    }
                );

                this.store.prices.priceSizeUpcharge = upchargePrice;
                this.store.prices.priceColorUpcharge = colorUpcharge;
                console.error(this.store.prices);

                this.store.totalSizesQty[this.store.imprintKey] = total;
                console.error("this.store.prices");
                console.warn(this.store.prices);
                console.warn(this.store.prices.tier);

                console.warn(priceByQty);
                /*
                this.store.prices.tier.forEach(
                    item => {
                        if(item.QtyMin !== "MSRP" total);
                    }
                );*/

                console.log(this.store.totalSizesQty[this.store.imprintKey]);
                console.log("@@@@ this.store.upchargesLines >>>>");
                console.log(this.store.colorSizeLines);
            },
            checkErrorQty(value){
              this.qtyError = value.qtyError;
            },
            setEnabledSizeForColor() {
                let enabledSizesForColor = {};
                let simpleArray = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].simple_array;
                console.log("setEnabledSizeForColor");
                console.log(simpleArray);

                for (let simple in simpleArray) {
                    let simpleData = simpleArray[simple];
                    if (simpleData.status == 'Enabled') {
                        if (!Object.hasOwn(enabledSizesForColor, simpleData.color)) {
                            enabledSizesForColor[simpleData.color] = {};
                        }
                        enabledSizesForColor[simpleData.color][simpleData.size] = simpleData.size;
                    }
                }

                this.enabledSizesForColor = enabledSizesForColor;
                console.log("this.enabledSizesForColor");
                console.log(this.enabledSizesForColor);
            },
        },
        created() {
            this.getAssociatedIds();
           // this.getAliases();
           // this.getProductById(8224285557053);
            console.log("this.associatedIds");
            console.log(this.associatedIds);
            this.init();
            
            if (this.getAssociatedIds && this.associatedIds.simples.id_color) {
                this.getProductById(this.associatedIds.simples.id_color, 'color');
            }

            if (this.getAssociatedIds && this.associatedIds.simples.id_size) {
                this.getProductById(this.associatedIds.simples.id_size, 'size');
            }

            if (this.store.productType === 'grouped_plain') {
              if (!this.associatedIds.simples.id_size || this.associatedIds.simples.id_size && this.store.inputProductData.sizeVariants.data == null) {
                this.addOneQtyField();
              }
            }

            if(this.store.productType !== 'grouped_plain') {
                this.setEnabledSizeForColor();
            }
            // if(this.lineIndex !== 0) {
                this.selectDefaultColorByLine();
            // }


            console.error("++++++++++++++++Selected colors and sizes");
            console.log(this.store.colorSizeLines);
            console.error("lineIndex>>> Created");
            console.log(this.lineIndex);
            console.warn("this.store.inputProductData.sizeVariants");
            console.log(this.store.inputProductData.sizeVariants);
        },
        computed: {
            customColor() {
                return this.$getCustomColorClass(store.storeID);
            },
        },
    }
</script>

<style>

.remove-color-line-wrapp .remove-color-line__btn {
    font-size: 9px;
    cursor: pointer;
}

.remove-color-line-wrapp .remove-color-line__btn:hover{
    text-decoration: underline;
}

.img-preview-section {
    padding: 0 15px;
}

.img-preview-background-wrapper {
    border: 1px solid rgb(90,90,90);
    line-height: 0;
}


.color-picker-btn {
    width: 25px;
    height: 25px;
    margin: 5px;
    border: 1px solid #c1c1c1;
}

.color-picker-btn.color-picker-btn--selected {
    border: 2px solid rgb(90,90,90);
}
.color-size-main-wrapper {
    display: flex;
    width: 100%;
    margin: 15px 0 20px 0;
}
.img-preview-section {
    width: 30%;
}

.color-size-section {
    width: 70%;
    text-align: left;
    padding-top: 5px;
}

.color-row-label,.size-row-label {
    font-size: 16px;
    line-height: 22px;
}
.color-row-label--sub {
    font-weight: 300;
    font-size: 12px;
    line-height: 17px;
}

.color-size-section .size-row {
    display: flex;
    flex-wrap: wrap;
}

.color-size-section .size-row .qty-wrap {
    display: flex;
    width: 90px;
    margin: 5px;
    flex-wrap: wrap;
}

.color-size-section .size-row .qty-wrap label {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
}

.color-size-section .size-row .qty-wrap label .sub_upcharge {
    font-size: 11px;
    font-weight: 300;
    font-style: italic;
}

.color-size-section .size-row .qty-wrap label span {
    line-height: 17px;
    font-size: 12px;
}

.color-size-section .size-row .size-row__input {
    height: 22px;
    min-height: 22px;
    max-height: 22px;
    max-width: 65px;
    width: 46px;
    margin: 0;
    text-align: center;
    padding: 0;
}

.color-size-section .size-row .controls-container {
    width: 22px;
    height: 22px;
    max-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(90, 90, 90);
    cursor: pointer;
    z-index: 1;
}

.color-size-section .size-row .controls-container span {
    color: #fff;
    font-weight: bold;
}

.plus-qty::selection,
.minus-qty::selection
{
    background: transparent;
    color: #fff;
}

.color-size-section .color-row{
  margin-bottom: 15px;
}

.color-size-section .color-row button{
  background-position: center;
}

</style>